export const FISCAL_STATUS_CONTINGENCY = ["M0015", "MC015"];

export const FISCAL_STATUS_APPROVED = ["06000", "150", "100"];

export const FISCAL_STATUS_CONNECTION_ERROR = ["M0020"];
